'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));

var styles = {"svgIcon":"arrive_SVGIcon__svgIcon"};

var SVGIcon = function SVGIcon(_ref) {
  var svgRef = _ref.svgRef,
      style = _ref.style,
      alt = _ref.alt,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    alt: alt,
    style: style,
    className: "".concat(styles.svgIcon, " ").concat(className),
    viewBox: "".concat(svgRef.viewBox)
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(svgRef.id)
  }));
};

SVGIcon.displayName = "SVGIcon";
SVGIcon.propTypes = {
  svgRef: PropTypes.object.isRequired,
  alt: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

module.exports = SVGIcon;
